import { useCollectionsContext } from '../context/CollectionsContext';

export const useRequireCollectionsProvider = (componentName: string) => {
    const context = useCollectionsContext();

    if (!context?.hasProvider) {
        throw new Error(`${componentName} must be used within a CollectionsProvider`);
    }

    return context;
};
